<template>
    <b-row>
    <b-col class="p-0">
            <div class="mb-2 mt-2">
                <officers-map
                    key="officerMap"
                    :geojson="geojson"
                    :loaded="loaded"
                    :officers="officers"
                    :roles="roles"
                />
            </div>
            <div class="mb-2">
                <asset-map
                    key="AssetMap"
                    :geojson="geojson"
                    :loaded="loaded"
                    :assets="assets"
                    :asset-types="assetTypes"
                />
            </div>
        </b-col>
    </b-row>
</template>

<script>
import graphMixins from '@/mixins/graphMixins'
import OfficersMap from '../Dashboard/OfficersMap'
import AssetMap from '../Dashboard/AssetMap'
import L from 'leaflet'
import jamaica_parishes_geojson from '../../exports/geoserver-GetFeature.json'

const defaultLocation = L.latLng(18, -77.2)

export default {
    name: 'officers-map2',
    components: {
        OfficersMap,
        AssetMap,
    },
    mixins: [graphMixins],
    props: {
        officers: {
            type: Array,
            default: () => [],
        },
        roles: {
            type: Array,
            default: () => [],
        },
        assets: {
            type: Array,
            default: () => [],
        },
        assetTypes: {
            type: Array,
            default: () => [],
        },
        value: {
            type: Object,
            default: () => defaultLocation,
        },
        loaded: {
            type: Boolean,
            default: () => false,
        },
    },
    data() {
        return {
            geojson: jamaica_parishes_geojson,
            assetTypeId: null,
            assetSearch: '',
            // loaded: false,
        }
    },
    filters: {
    },

    computed: {
    },

    methods: {
    },
}
</script>

<style>
.autocomplete input {
    border-radius: 0;
}

.leaflet-div-icon {
    background: none;
    border: none;
}

#map.fullscreen {
    z-index: 9;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
}

#map {
    height: 418px;
    z-index: 0;
}

.map-custom-control {
    background: #fff;
    padding: 0 0.5em;
    border: 1px solid #aaa;
    border-radius: 0.1em;
}

dl {
    display: grid;
    grid-template-columns: max-content auto;
}

dt {
    grid-column-start: 1;
}

dd {
    grid-column-start: 2;
}

.popup_header {
    text-decoration: underline;
    font-weight: bold;
}

.popup_label {
    font-weight: bold;
}
</style>
